import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AdjustmentTypes() {
  return (
    <div className="flex flex-col gap-4 h-max">
      <Crud
        title="Adjustment Types"
        getUrl={() => "/Player/AdjustmentType_GetList"}
        // INSERT
        insertUrl={() => "/Player/AdjustmentType_Insert"}
        insertParams={(
          { userId },
          { adjustmentTypeName }
        ) => ({
          AdjustmentTypeName: adjustmentTypeName,
          IdUser: Number(userId),
        })}
        // UPDATE
        updateUrl={() => "/Player/AdjustmentType_Update"}
        updateParams={(
          { userId },
          { idAdjustmentType, adjustmentTypeName }
        ) => ({
          IdAdjustmentType: idAdjustmentType,
          AdjustmentTypeName: adjustmentTypeName,
          IdUser: Number(userId),
        })}
        // DELETE
        deleteUrl={() => "/Player/AdjustmentType_Delete"}
        deleteParams={({ userId }, id) => ({
          IdAdjustmentType: id,
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idAdjustmentType"
        >
          IdAdjustmentType
        </TableHeaderColumn>
        <TableHeaderColumn dataField="adjustmentTypeName">
          Name
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default AdjustmentTypes;
